/* tslint:disable */
/* eslint-disable */
export enum ServiceafregningBasisEnum {
  Serviceaftale = 'Serviceaftale',
  Serviceordre = 'Serviceordre',
  Slutopgoerelse = 'Slutopgoerelse'
}
